import React, { useState } from "react";
import Prices from "./Prices";
import Promotions from "./Promotions";
import Users from "./Users";
import Reports from "./Reports";
import { t } from "@lingui/macro";

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState("Prices");

  const renderContent = () => {
    switch (activeTab) {
      case "Prices":
        return <Prices />;
      case "Promotions":
        return <Promotions />;
      case "Users":
        return <Users />;
      case "Reports":
        return <Reports />;
      default:
        return <Prices />;
    }
  };

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <h1>{t`Management Dashboard`}</h1>
      </header>
      <nav className="dashboard-tabs">
        <button
          className={activeTab === "Prices" ? "tab active" : "tab"}
          onClick={() => setActiveTab("Prices")}
        >
          {t`Prices`}
        </button>
        <button
          className={activeTab === "Promotions" ? "tab active" : "tab"}
          onClick={() => setActiveTab("Promotions")}
        >
          {t`Promotions`}
        </button>
        <button
          className={activeTab === "Users" ? "tab active" : "tab"}
          onClick={() => setActiveTab("Users")}
        >
          {t`Users`}
        </button>
        <button
          className={activeTab === "Reports" ? "tab active" : "tab"}
          onClick={() => setActiveTab("Reports")}
        >
          {t`Reports`}
        </button>
      </nav>
      <main className="dashboard-content">{renderContent()}</main>
    </div>
  );
};

export default Dashboard;
